import React, { Component } from "react";
import axios from "axios";

class AxiosCallCellRenderer extends Component {

  constructor(props) {
    super(props);
    this.imageClickedHandler = this.imageClickedHandler.bind(this);
  }

  imageClickedHandler(e) {
    var imageURL = "";
    var manifestID = this.props.value;
    var drive = this.props.data.Drive;
    var fileType = ".tif";
    if (drive === "R") {
      //RCRA URL
      imageURL = `/api/v1/hwts/manifest-images/rcra/download?manifestID=${manifestID}`;
      fileType = ".zip"
    }
    else if (this.props.data.DocAiManifestImageId) {
      // Doc AI URL
      imageURL = `/api/v1/hwts/manifest-images/doc-ai/download?id=${this.props.data.DocAiManifestImageId}`;
      fileType = ".pdf";
    }
    else {
      //Local URL
      if (drive === "E") {
        fileType = ".pdf";
      }
      imageURL = `/api/v1/hwts/manifest-images/dtsc/download?drive=${drive}&DPath=${this.props.data.DPath}&path=${this.props.data.Path}&&fileName=${this.props.data.FileName}${fileType}`;
    }

    axios({
      url: imageURL,
      method: 'GET',
      responseType: 'blob', // important
    }).then((res) => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      let filename = `${manifestID}${fileType}`;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }).catch((err) => {
      alert("The Manifest image is not available at this time. Please try again later.");
    });
    e.preventDefault(); // don't follow href
  }
  render() {
    return (
      <a href="#download-manifest-image" onClick={this.imageClickedHandler}>{this.props.value}</a>
    )
  }
}

export default AxiosCallCellRenderer;